import { Button, Flex, FormControl, FormErrorMessage, FormLabel, Grid, HStack, Input, Select, Text, useToast } from '@chakra-ui/react'
import { useNavigate, useParams } from 'react-router-dom'
import { FormProvider, useForm } from 'react-hook-form'
// import InputMask from "react-input-mask";
import { useUpdateUser } from 'hooks/useUsers'

import Layout from 'components/ManagerLayout'
import FormCard from 'components/FormCard'
import { useSelector } from 'react-redux'
import { State } from 'state/reducers'
import SkeletonInput from 'components/SkeletonInput'
import sanitizeForm from 'functions/sanitizeForm'
import { yupResolver } from '@hookform/resolvers/yup'
import schema from './userFormSchema'
import { isEmpty } from 'lodash';

const EditUser = () => {
	const { id } = useParams();
	const navigate = useNavigate();
	
	// const { isLoading } = useGetUser(id);

	const user = useSelector(({ users }: State) => users).data.find(user => user.id === id)

	const methods = useForm({
		mode: 'onBlur',
		reValidateMode: 'onBlur',
		resolver: yupResolver(schema)
	});
	const toast = useToast();

	const {
		register,
		handleSubmit,
		formState: { errors },
		getValues
	} = methods;

	const [updateUser, { loading }] = useUpdateUser({
		onSuccess: (data: any) => {
			toast({
				title: 'Usuário atualizado com sucesso.',
				status: 'success',
				duration: 5000,
				isClosable: true
			});
			// navigate('../administracao/usuarios/' + data.id);
		},
		onError: () => {
			toast({
				title: 'Ocorreu um erro',
				status: 'error',
				duration: 5000,
				isClosable: true
			});
		}
	});

	const onSubmit = (data: any) => {
        const formData = sanitizeForm(data);

        const variables = {
            input: {
				id: user?.id,
                ...formData
            }
        }

        updateUser({ variables });
    };

	return (
		<Layout>
			<FormCard title="Editar Usuário">
				<FormProvider  {...methods}>
					<form
						style={{ width: '100%' }}
						onSubmit={handleSubmit(onSubmit)}
					>
						<Flex direction="column" w="100%">
							<Grid
								w="full"
								templateColumns={{ sm: "1fr", md: "repeat(2, 1fr)" }}
								gap="24px"
								mb="24px"
							>
								<FormControl isInvalid={!isEmpty(errors.name)}>
									<FormLabel
										fontWeight="bold"
										fontSize="xs"
									>
										Nome completo
									</FormLabel>
									<Input
										{...register("name")}
										defaultValue={user?.name}
										borderRadius="8px"
										fontSize="md"
									/>
									<FormErrorMessage>
										{errors.name?.message}
									</FormErrorMessage>
								</FormControl>
                                <FormControl isInvalid={!isEmpty(errors.email)}>
                                    <FormLabel
                                        fontWeight="bold"
                                        fontSize="xs"
                                    >
                                        E-mail
                                    </FormLabel>
                                    <Input
                                        {...register("email")}
										defaultValue={user?.email}
                                        borderRadius="8px"
                                        fontSize="md"
                                    />
                                    <FormErrorMessage>
                                        {errors.email?.message}
                                    </FormErrorMessage>
                                </FormControl>
                                <FormControl isInvalid={!isEmpty(errors.role_id)}>
                                    <FormLabel
                                        fontWeight="bold"
                                        fontSize="xs"
                                    >
                                        Tipo de Usuário
                                    </FormLabel>
                                    <Select
                                        placeholder="Seleciona uma opção"
                                        {...register("role_id")}
										defaultValue={user?.role.id}
										disabled
                                    >
                                        {/* <option value="1">Super Admin</option> */}
                                        <option value="2">Administrador</option>
                                    </Select>
                                    <FormErrorMessage>
                                        {errors.role_id?.message}
                                    </FormErrorMessage>
                                </FormControl>
							</Grid>
							<Flex w="full" justifyContent="flex-end">
								<HStack spacing={4}>
									<Button
										onClick={() => navigate('./../..')}
										disabled={loading}
										variant="ghost"
										colorScheme="gray"
										size="md"
									>
										Cancelar
									</Button>
									<Button
										type="submit"
										isLoading={loading}
										disabled={loading}
										colorScheme="green"
									>
										Atualizar
									</Button>
								</HStack>
							</Flex>
						</Flex>
					</form>
				</FormProvider>
			</FormCard>
		</Layout>
	)
}

export default EditUser